import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, UrlTree } from '@angular/router';

import { LoginEntryDecision, LoginEntryPolicy } from '@home/login/services';

@Injectable({
  providedIn: 'root',
})
export class AuthenticatedRedirectGuard implements CanActivate {
  constructor(private readonly loginEntryPolicy: LoginEntryPolicy, private readonly router: Router) {}

  canActivate(route: ActivatedRouteSnapshot): boolean | UrlTree {
    const decision = this.loginEntryPolicy.resolve(route?.queryParams);

    return decision === LoginEntryDecision.GoHome ? this.router.parseUrl('/home') : true;
  }
}
